import State from '../core/State';
import { VisitorData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingPurchasers = () =>
  produce((draft: Draft<State>) => {
    draft.purchasers.fetching = draft.purchasers.fetching + 1;
  });

export const setPurchasers = (salesData: VisitorData) =>
  produce((draft: Draft<State>) => {
    draft.purchasers.data = salesData;
  });

export const finishFetchingPurchasers = () =>
  produce((draft: Draft<State>) => {
    draft.purchasers.fetching = draft.purchasers.fetching - 1;
  });

export const disposePurchasers = () =>
  produce((draft: Draft<State>) => {
    draft.purchasers.data = initialState.purchasers.data;
    draft.purchasers.fetching = initialState.purchasers.fetching;
  });
